import GroupOrgSelect from './src/main';

/* istanbul ignore next */
GroupOrgSelect.install = function(Vue) {
  Vue.component(GroupOrgSelect.name, GroupOrgSelect);
};

export default GroupOrgSelect;
